import { Component, EventEmitter, Input, Output, ChangeDetectorRef, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { LoaderComponent } from '../../../../../shared/elements/loader/loader.component';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatInput } from '@angular/material/input';
import { DisableDragDropDirective } from '../../../../../shared/directives/disable-drag-drop.directive';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { IntegerOnlyDirective } from '../../../../../shared/directives/integeronly.directive';
import { Ng2SearchPipe } from '../../../../../shared/pipe/Ng2SearchPipeModule.pipe';

@Component({
    selector: 'app-forecast-add-service-popup',
    templateUrl: './forecast-add-service-popup.component.html',
    styleUrl: './forecast-add-service-popup.component.css',
    imports: [LoaderComponent, MatFormField, MatSelect, FormsModule, MatOption, MatTooltip, MatRadioGroup, MatRadioButton, MatInput, DisableDragDropDirective, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, IntegerOnlyDirective, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, Ng2SearchPipe]
})
export class ForecastAddServicePopupComponent implements OnChanges {
  @Input() dataSource: any = {};
  @Input() masterServicesData: any = {};
  @Input() allNewApps: any = {};
  @Input() modalType: string = 'service';
  @Input() loggedInUserRoles;
  @Input() marginLessDetails: object = {};
  allowNegative: boolean = false;
  servicesData: any = [];
  lobLoader = false;
  internationalService;
  selectedService: any = {};
  forecastCycle: any = {};
  internationalTooltipMsg =
    'Services that are located outside of United States have different rates and should be identified as International';
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  columns = [
    { label: 'Year', key: 'Year', disable_key: 'Year' },
    { label: 'Jan', key: 'QNT_Jan', disable_key: 'QNT_Jan_disabled' },
    { label: 'Feb', key: 'QNT_Feb', disable_key: 'QNT_Feb_disabled' },
    { label: 'Mar', key: 'QNT_Mar', disable_key: 'QNT_Mar_disabled' },
    { label: 'Apr', key: 'QNT_Apr', disable_key: 'QNT_Apr_disabled' },
    { label: 'May', key: 'QNT_May', disable_key: 'QNT_May_disabled' },
    { label: 'Jun', key: 'QNT_Jun', disable_key: 'QNT_Jun_disabled' },
    { label: 'Jul', key: 'QNT_Jul', disable_key: 'QNT_Jul_disabled' },
    { label: 'Aug', key: 'QNT_Aug', disable_key: 'QNT_Aug_disabled' },
    { label: 'Sep', key: 'QNT_Sep', disable_key: 'QNT_Sep_disabled' },
    { label: 'Oct', key: 'QNT_Oct', disable_key: 'QNT_Oct_disabled' },
    { label: 'Nov', key: 'QNT_Nov', disable_key: 'QNT_Nov_disabled' },
    { label: 'Dec', key: 'QNT_Dec', disable_key: 'QNT_Dec_disabled' }
  ];
  columnsToDisplay = this.columns.map(element => element.label);
  years = [];
  serviceSearch = '';
  servicesDataMaster: any;
  disableApply = true;
  @Output() refreshService: EventEmitter<any> = new EventEmitter();
  tableDataSource: any[];
  FAGI: any;
  appName: string = '';
  billingSegment: string = '';
  appId: string;
  selectedGloablAppCode: any;
  allowCmServicesEdit = false;
  marginLessApplicable = [];

  constructor(
    public maintenanceService: MaintenanceService,
    public toastrService: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges() {
    this.selectedService = {};
    this.internationalService = null;
    this.servicesData = [];
    this.disableApply = true;
    this.appName = "";
    this.billingSegment = "";
    this.years.forEach(year => {
      year['forecast'] = 0;
    });
    if (Object.keys(this.masterServicesData).length > 0) {
      this.forecastCycle = this.masterServicesData['forecastData'].filter(item => item.Previous != 'Yes')[0];
      if (this.years.length == 0) {
        this.populateYears();
      }
    }
    if (this.tableDataSource && this.tableDataSource.length > 0) {
      this.tableDataSource.forEach(element => {
        this.months.forEach(month => {
          element['QNT_' + month] = 0;
        });
      });
    }

    if (this.dataSource) {
      this.getMarginLessDetails();
      this.allowNegative =
        this.dataSource['ask_global_id'] && this.dataSource['ask_global_id'].toLowerCase().includes('topsides')
          ? true
          : false;
      this.checkRoleForTopsidesToAllowCmServicesAddition();
    }
  }

  serviceTypeChange() {
    this.servicesDataMaster =
      this.internationalService == 'true'
        ? JSON.parse(JSON.stringify(this.masterServicesData.international))
        : JSON.parse(JSON.stringify(this.masterServicesData.domestic));
    this.servicesDataMaster.forEach(service => {
      if (this.dataSource && Object.keys(this.dataSource).length > 0) {
        if (
          this.dataSource['services'].findIndex(item => item.service == service.Service) > -1 ||
          service.Edit_TOH != 'Yes'
        ) {
          service.disabled = true;
        } else {
          service.disabled = false;
        }
      } else {
        if (service.Edit_TOH != 'Yes') {
          service.disabled = true;
        } else {
          service.disabled = false;
        }
      }
      if (service.SRV_Disable == 'DISABLE' && this.allowCmServicesEdit) {
        service.disabled = false;
      }
    });
    this.servicesData = this.servicesDataMaster;
    this.disableApply = true;
    this.serviceSearch = '';
  }

  serviceChange(event) {
    this.selectedService = event.value;

    if (this.modalType == 'app' && !this.selectedGloablAppCode) {
      this.disableApply = true;
    } else {
      this.disableApply = false;
    }
    if (this.marginLessApplicable.length > 0) {
      const startYear = this.forecastCycle['FC_Start_Month'].split(',')[0];
      const endYear = this.forecastCycle['FC_End_Month'].split(',')[0];
      if (this.marginLessApplicable[0]['Marginless_Years'].split(',').includes(startYear)) {
        if (
          this.marginLessDetails['services'].findIndex(row => row['Service'] == this.selectedService['Service']) > -1
        ) {
          this.selectedService['Rate'] = this.marginLessDetails['services'].find(
            row => row['Service'] == this.selectedService['Service'] && row['Year'] == parseInt(startYear)
          )['Rate_marginless'];
          this.selectedService['Future_Year_Rate'] = this.marginLessDetails['services'].find(
            row => row['Service'] == this.selectedService['Service'] && row['Year'] == parseInt(endYear)
          )['Rate_marginless'];
        }
      }
    }
  }

  populateYears() {
    this.years = [];
    if (!this.forecastCycle || !this.forecastCycle.FC_Start_Month || !this.forecastCycle.FC_End_Month) {
      console.warn('forecastCycle or its required properties are missing');
      return;
    }
    const startMonth = this.forecastCycle['FC_Start_Month'].split(',')[1];
    const startYear = this.forecastCycle['FC_Start_Month'].split(',')[0];
    const endMonth = this.forecastCycle['FC_End_Month'].split(',')[1];
    const endYear = this.forecastCycle['FC_End_Month'].split(',')[0];
    const startMonthIndex = this.months.indexOf(startMonth);
    const endMonthIndex = this.months.indexOf(endMonth);
    if (startYear == endYear) {
      for (let i = 0; i < this.months.length; i++) {
        this.years.push({
          month: startYear + '-' + (i + 1 >= 10 ? i + 1 : '0' + (i + 1)),
          forecast: 0,
          disabled: i < startMonthIndex || i > endMonthIndex,
          year: startYear,
          MM: this.months[i]
        });
      }
    } else {
      for (let i = 0; i < this.months.length; i++) {
        this.years.push({
          month: startYear + '-' + (i + 1 >= 10 ? i + 1 : '0' + (i + 1)),
          forecast: 0,
          disabled: i < startMonthIndex,
          year: startYear,
          MM: this.months[i]
        });
      }
      for (let i = parseInt(startYear) + 1; i < parseInt(endYear); i++) {
        for (let j = 0; j < this.months.length; j++) {
          this.years.push({
            month: i + '-' + (j + 1 >= 10 ? j + 1 : '0' + (j + 1)),
            forecast: 0,
            disabled: false,
            year: i,
            MM: this.months[j]
          });
        }
      }
      for (let i = 0; i < this.months.length; i++) {
        this.years.push({
          month: endYear + '-' + (i + 1 >= 10 ? i + 1 : '0' + (i + 1)),
          forecast: 0,
          disabled: i > endMonthIndex,
          year: endYear,
          MM: this.months[i]
        });
      }
    }
    this.tableDataSource = [];
    this.years.forEach(ele => {
      const index =
        this.tableDataSource.length > 0 ? this.tableDataSource.findIndex(forecast => forecast.Year == ele.year) : -1;
      if (index != -1) {
        this.tableDataSource[index]['QNT_' + ele.MM] = ele.forecast;
        this.tableDataSource[index]['QNT_' + ele.MM + '_disabled'] = ele.disabled;
      } else {
        const temp = {
          Year: ele.year
        };
        temp['QNT_' + ele.MM] = ele.forecast;
        temp['QNT_' + ele.MM + '_disabled'] = ele.disabled;
        this.tableDataSource.push(temp);
      }
    });
  }
  onlyNumberKey(event) {
    const pattern2 = this.allowNegative ? /^-?\d*$/ : /^\d*$/;
    const inputChar = event.type != 'paste' ? String.fromCharCode(event.charCode) : event.clipboardData.getData('text');
    const currentValue = (event.target as HTMLInputElement).value;
    const newValue = currentValue + inputChar;
    if (!pattern2.test(newValue)) {
      event.preventDefault();
    }
  }
  searchService(event) {
    if (event.target.value.length == 0) {
      this.servicesData = this.servicesDataMaster;
      return;
    }
    this.servicesData = this.servicesDataMaster.filter(service =>
      service.Service_Name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    this.servicesData =
      this.servicesData.length == 0 ? [{ Service_Name: 'No results found', disabled: 1 }] : this.servicesData;
  }

  apply() {
    const payload = [];
    const item = {};
    item['Service'] = this.selectedService['Service'];
    item['SV_Desc'] = this.selectedService['Service_Name'];
    item['ASK_Global_Id'] = item['ASK_Global_Id'] =
      this.modalType == 'app' ? this.appId : this.dataSource['ask_global_id'];
    // item['CY_Rate'] = this.selectedService['Rate'];
    item['Unit_Of_Measure'] = this.selectedService['Unit_Of_Measure'];
    item['I_Flag'] = this.selectedService['I_Flag'];
    item['Forecast_Cycle'] = this.forecastCycle['Forecast_Cycle'];
    item['Service_Owner_Email'] = this.selectedService['Service_Owner_Email'];
    item['Service_Owner'] = this.selectedService['Service_Owner_Name'];
    item['Service_Owner_MSID'] = this.selectedService['Service_Owner_msid'];
    item['LONG_APP_NAME'] = this.modalType == 'app' ? this.appName : this.dataSource['app_name'];
    item['Edit_TOH'] = this.selectedService['Edit_TOH'];
    item['AO_AD_Edit'] = this.modalType == 'app' ? '' : this.dataSource['AO_AD_Edit'];
    item['FA_SFA_Edit'] = this.modalType == 'app' ? '' : this.dataSource['FA_SFA_Edit'];
    const lastYear = {
      year: parseInt(this.forecastCycle['FC_Start_Month'].split(',')[0]) - 1
    };
    this.months.forEach(month => {
      lastYear['QNT_' + month] = 0;
    });
    payload.push({ ...item, ...lastYear });

    this.tableDataSource.forEach(element => {
      const obj = {
        year: parseInt(element.Year)
      };
      this.months.forEach(month => {
        const value = element['QNT_' + month]
          ? this.allowNegative
            ? element['QNT_' + month].replace(/(?!^)-|[^0-9-]/g, '')
            : element['QNT_' + month].replace(/[^0-9]*/g, '')
          : '0';
        obj['QNT_' + month] = isNaN(parseInt(value)) ? 0 : parseInt(value);
      });
      payload.push({ ...item, ...obj });
    });
    this.maintenanceService.addService(payload).subscribe(
      response => {
        this.disableApply = true;
        this.selectedGloablAppCode = null;
        this.FAGI = '';
        this.appName = '';
        this.billingSegment = '';
        this.internationalService = null;
        this.selectedService = null;
        this.serviceSearch = '';

        
        this.tableDataSource = this.tableDataSource.map(row => {
          const resetRow = { ...row };
          this.months.forEach(month => {
            resetRow[`QNT_${month}`] = 0;
          });
          return resetRow;
        });


        // Optionally reset table data or other fields
        // this.tableDataSource = [];

        // Force change detection
        this.cdr.detectChanges();

        this.refreshService.emit(response[0]);
        this.toastrService.success('Service Added Successfully', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      },
      () => {
        this.toastrService.error('Something Went Wrong', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
    );
  }

  getMarginLessDetails() {
    if (Object.keys(this.marginLessDetails).length > 0) {
      this.marginLessApplicable = this.marginLessDetails['segments'].filter(row => {
        return (
          (row['OperatingUnitId'] && row['OperatingUnitId'] == this.dataSource['operating_unit_id']) ||
          (row['Billing_Segment'] != 'No Mapping' && row['Billing_Segment'] == this.dataSource['Billing_Segment'])
        );
      });
    }
  }

  checkRoleForTopsidesToAllowCmServicesAddition() {
    this.allowCmServicesEdit = false;
    if (
      this.dataSource['ask_global_id'] &&
      this.dataSource['ask_global_id'].toLowerCase().includes('topsides - ') &&
      this.loggedInUserRoles
    ) {
      if (this.loggedInUserRoles.filter((item: any) => item['User_Role'] == 'Forecast_Admin').length > 0) {
        this.allowCmServicesEdit = true;
      }
      if (
        this.loggedInUserRoles.filter(
          (item: any) =>
            item['User_Role'] == 'SRM' && item['Master_Segment'] == this.dataSource['Master_Billing_Segment']
        ).length > 0
      ) {
        this.allowCmServicesEdit = true;
      }
    }
  }
  showAppAndBillingSegment(event: any) {
    if (this.modalType == 'app' && Object.keys(this.selectedService).length === 0) {
      this.disableApply = true;
    } else {
      this.disableApply = false;
    }

    const payload = {
      ask_global_id: [event.value.app_id]
    };

    this.maintenanceService.getForecastDetails(payload).subscribe({
      next: response => {
        if (response.length === 0) {
          this.dataSource = {};
        }
        else {
          this.dataSource = response[0];
        }
      },
      error: error => {
        console.error('Error fetching data:', error);
      }
    });
    this.appName = event.value.long_name;
    this.billingSegment = event.value.Billing_Segment;
    this.appId = event.value.app_id;
  }
}
